export default __webpack_public_path__ + "static/media/cert-E-commerce-cpttm.78513f51.jpg";